/* istanbul ignore file */
import { ProjectToolMessageCallback } from 'domain/projects/shared/projectToolsCreation';

const useCreateSharepointResponseHandler = () => {
  const handleSharepointCreationStatus = (sharepointCreationStatus: any, callback: ProjectToolMessageCallback) => {
    if (sharepointCreationStatus.isCreated) {
      callback({ type: 'log', level: 'success', message: `Successfully created SharePoint document storage.` });
      return true;
    } else {
      callback({
        type: 'log',
        level: 'error',
        message: `Failed to create SharePoint document storage due to: ${sharepointCreationStatus.errors.join(' ')}.`,
      });
      return false;
    }
  };

  const handleProjectFieldUpdatedStatus = (projectFieldUpdatedStatus: any, callback: ProjectToolMessageCallback) => {
    if (projectFieldUpdatedStatus.isUpdated) {
      callback({ type: 'log', level: 'success', message: `Successfully updated Project link to the SharePoint.` });
      return true;
    } else {
      callback({
        type: 'log',
        level: 'error',
        message: `Failed to update Project link to the SharePoint due to: ${projectFieldUpdatedStatus.errors.join(' ')}.`,
      });
      return false;
    }
  };

  const handleSharepointResponse = (state: any, callback: ProjectToolMessageCallback) => {
    let isPassed = true;

    if (state.sharepointCreationStatus) {
      isPassed = handleSharepointCreationStatus(state.sharepointCreationStatus, callback) && isPassed;
    }
    if (state.projectFieldUpdatedStatus) {
      isPassed = handleProjectFieldUpdatedStatus(state.projectFieldUpdatedStatus, callback) && isPassed;
    }

    callback({ type: 'status', status: isPassed ? 'passed' : 'failed' });
  };

  return {
    handleSharepointResponse,
  };
};

export default useCreateSharepointResponseHandler;
